import React from 'react';
import { Popover, PopoverTrigger, PopoverContent } from "@shadcn-in-nx/ui/popover";
import { Button } from "@shadcn-in-nx/ui/button";
import { Calendar } from "@shadcn-in-nx/ui/calendar";
import { CalendarIcon } from "lucide-react";
import { format, parseISO } from "date-fns";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";

export function DateInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  autoFocus = true,
  className
}) {
  const [isOpen, setIsOpen] = React.useState(true);

  // Transformar valor (YYYY-MM-DD string) en objeto Date para el componente Calendar
  let dateValue = undefined;
  if (value && typeof value === 'string') {
    // Para asegurarse que date-fns pueda parsearlo correctamente. YYYY-MM-DD es compatible con parseISO.
    const dt = new Date(value + 'T00:00:00');
    if (!isNaN(dt.getTime())) {
      dateValue = dt;
    }
  }

  const handleSelect = (date) => {
    if (date) {
      const formatted = format(date, 'yyyy-MM-dd');
      onChange(formatted);
      onSave(formatted);
    } else {
      onChange(null);
      onSave(null);
    }
    setIsOpen(false);
    onCancel();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
      onCancel();
    }
  };

  const handleOpenChange = (open) => {
    setIsOpen(open);
    if (!open) {
      onCancel();
    }
  };

  const placeholderClass = !value ? "text-muted-foreground" : "";
  const errorClass = error ? `${className} border-red-500 focus-visible:ring-red-500` : className;

  return (
    <div className={'w-full flex flex-col h-full'}>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
              <Popover open={isOpen} onOpenChange={handleOpenChange}>
                {/* Usamos el container como control de foco, el Popover por defecto lo maneja. */}
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    className={errorClass}
                    onKeyDown={handleKeyDown}
                    autoFocus={autoFocus}
                  >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {dateValue ? format(dateValue, "MMM dd, yyyy") : <span>Pick a date</span>}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                  <Calendar
                    mode="single"
                    selected={dateValue}
                    // cast the parameter since Calendar gives Date | undefined natively
                    onSelect={handleSelect}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
